import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from 'reactstrap';
import moment from 'moment';

const SessionDeletionWarningModal = ({
  isOpen,
  toggle,
  affectedSessions,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Sessions Will Be Deleted</ModalHeader>
      <ModalBody>
        <p>
          The following sessions with attendance records will be deleted:
        </p>
        <Table striped size="sm">
          <thead>
            <tr>
              <th>Date</th>
              <th>Patient</th>
              <th>Attendance</th>
            </tr>
          </thead>
          <tbody>
            {affectedSessions.map((session, index) => (
              <tr key={index}>
                <td>{moment(session.date).format('MM/DD/YYYY')}</td>
                <td>{session.patientName}</td>
                <td>{session.attendanceStatus}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <p className="text-danger mt-3">
          <strong>Warning:</strong> This action cannot be undone. The sessions and
          their attendance records will be permanently deleted.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button color="danger" onClick={onConfirm}>
          Proceed Anyway
        </Button>
      </ModalFooter>
    </Modal>
  );
};

SessionDeletionWarningModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  affectedSessions: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      patientName: PropTypes.string,
      attendanceStatus: PropTypes.string,
    })
  ).isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default SessionDeletionWarningModal;
